import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  const $dataFillFields = $('[data-fill-fields]')
  debugLogScriptName($dataFillFields, 'fill-fields.js') // DEBUG
  $dataFillFields
    .on('change', function(e) {
      var $el = $(this),
        $form = $el.closest('form'),
        url = $el.attr('data-fill-fields'),
        key = $el.val(),
        $additionalFields = $form.find('[data-fill-field-disabled]') // Extra velden die meegenomen moeten worden

      if (key) {
        $.ajax({
          method: 'GET',
          url: url.replace('_id', key),
          dataType: 'json',
        }).done(function(data) {
          var keys = []

          $.each(data, function(key, val) {
            var $el = $form
              .find('[name="' + key + '"]')
              .val(val)
              .prop('disabled', true)

            keys.push(key)
          })

          $additionalFields.each(function() {
            var $el = $(this)
              .prop('disabled', true)
              .prop('checked', false)
              .trigger('change') // Zet de extra velden ook op disabled, uncheck ze en trigger change zodat hide-disable.js zijn werk kan doen

            keys.push($el.attr('name'))

            if ($el.attr('type') == 'checkbox') {
              $el.parents('.checkbox').addClass('checkbox--disabled')
            }
          })

          $el.data('keys', JSON.stringify(keys)).trigger('fill-fields.filled')
        })
      } else {
        var keysString = $el.data('keys')

        if (keysString) {
          var keys = JSON.parse(keysString)

          $.each(keys, function(i, key) {
            var $el = $form.find('[name="' + key + '"]')

            $el.each(function() {
              // Er kunnen meerdere elementen zijn met dezelfde key, bij checkboxes met een default value bijvoorbeeld
              var $elm = $(this)
                .val('')
                .prop('disabled', false)

              if ($elm.attr('type') == 'checkbox') {
                $elm.parents('.checkbox').removeClass('checkbox--disabled')
              }
            })
          })
        }

        $el.trigger('fill-fields.emptied')
      }
    })
    .trigger('change')
})
